<template>
	<div>
		<fieldset class="single-choice" :disabled="question.answerStatus !== null">
			<div class="test__question__answer-label">
				Vyberte <b class="fw-700">jednu</b> možnost
			</div>

			<div class="test__question__choice" v-for="(choice, index) in choices" :key="choice.value"
				:class="{
					'selected': choice.value === selected,
					'pickedCorrectly': (question.answerStatus === 'answeredCorrectly' || question.answerStatus === 'answeredIncorrectly') && choice.pickedCorrectly,
					'pickedIncorrectly': (question.answerStatus === 'answeredCorrectly' || question.answerStatus === 'answeredIncorrectly') && !choice.pickedCorrectly
					}">
				<input type="radio" :id="'question-' + questionIndex + '-choice-' + index" v-model="selected" :value="choice.value">
				<label :for="'question-' + questionIndex + '-choice-' + index">
					<div class="test__question__choice__check">
						<span v-if="question.answerStatus !== 'answeredCorrectly' && question.answerStatus !== 'answeredIncorrectly'">
							{{ index + 1}}
						</span>
						<template v-if="question.answerStatus === 'answeredCorrectly' || question.answerStatus === 'answeredIncorrectly'">
							<svg v-if="choice.isCorrect === true" class="correct-icon" width="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19.162">
								<path d="M24.548,54.323,22.355,52.13a1.558,1.558,0,0,0-2.193,0L9.581,62.726,4.839,57.968a1.493,1.493,0,0,0-1.1-.451,1.493,1.493,0,0,0-1.1.451L.452,60.162a1.558,1.558,0,0,0,0,2.194L6.29,68.194l2.194,2.194a1.558,1.558,0,0,0,2.194,0l2.194-2.194L24.548,56.517a1.558,1.558,0,0,0,0-2.194Z" transform="translate(0 -51.678)"/>
							</svg>
							<svg v-if="choice.isCorrect === false" class="incorrect-icon" width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
								<path d="M8981.835,5919.737,8976,5913.9l-5.834,5.834a1.044,1.044,0,0,1-1.475,0l-2.386-2.383a1.045,1.045,0,0,1,0-1.475l5.835-5.835-5.835-5.834a1.045,1.045,0,0,1,0-1.475l2.386-2.385a1.04,1.04,0,0,1,1.473,0l5.835,5.835,5.836-5.835a1.043,1.043,0,0,1,1.475,0l2.384,2.383a1.044,1.044,0,0,1,0,1.477l-5.834,5.835,5.834,5.834a1.041,1.041,0,0,1,0,1.475l-2.384,2.383a1.04,1.04,0,0,1-1.475,0Z" transform="translate(-8966.001 -5900.044)"/>
							</svg>
						</template>
					</div>
					<div class="test__question__choice__text">
						<v-runtime-template :template="choice.text" />
					</div>
				</label>
			</div>

		</fieldset>
	
		<b-alert
			variant="danger"
			:show="this.evaluation.evaluated && this.question.answerStatus === null">
			{{ this.evaluation.message }}
		</b-alert>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: 'SingleChoice',

	props: ['questionIndex'],
	
	data() {
		return {
			selected: null, // Pro single choice 

			question: null,

			choices: [],

			evaluation: {
				evaluated: false,
				isCorrect: null,
				message: '',
			}
		};
	},

	// Příprava dat před tím, než se začne cokoliv vykonávat
	created() {
		this.question = this.$store.state.testData.questions[this.$props.questionIndex];
		
		this.prepareChoicesForMultipleAndSingleChoices();

		// Náhodné zamíchání možností, pokud má být
		if (this.question.choices_order === 'random') {
			this.shuffle(this.choices);
		}
	},

	methods: {
		...mapActions([
			'correctlyEvaluatedAnswer',
			'incorrectlyEvaluatedAnswer',
		]),

		evaluateAnswer() {
			this.evaluation.evaluated = true;

			if (this.selected !== null) {
				if (this.question.answerStatus === null) {
					this.evaluation.isCorrect = null; // Vynulování stavu

					// Vytvoření pole
					let userSelection = this.selected.split();

					// Vyhodnocení, jestli je otázka zodpovězena správně / nesprávně
					for (let element of this.choices) {
						if (element.value === this.selected && element.isCorrect) { // Podmínka, která zajistí, správné vyhodnocení výsledku
							this.evaluation.isCorrect = true;
							break;
						} else {
							this.evaluation.isCorrect = false;
							this.evaluation.message = 'Zkuste to radši znovu';
						}
					}

					// Na základě výsledku přidám ke každé choice v poli choices[] parametr pickedCorrectly = true / false (pokud daná choice byla vybraná správně / nesprávně)
					this.choices.forEach((choice, index) => {
						choice.pickedCorrectly
							= ((choice.isCorrect && this.selected === choice.value) || (!choice.isCorrect && this.selected !== choice.value))
							? true
							: false;
					});

					// Provede se po vyhodnocení správně/nesprávně zodpovězené otázky
					if (this.evaluation.isCorrect) {
						this.correctlyEvaluatedAnswer(this.$props.questionIndex);
						this.disableMultipleAndSingleChoices();
					} else {
						this.incorrectlyEvaluatedAnswer(this.$props.questionIndex);

						if (this.question.answerStatus === 'answeredCorrectly') {
							this.disableMultipleAndSingleChoices();
						}
					}
				}
			} else { // Pokud není vybraná žádná choice
				this.evaluation.message = 'Vyberte jednu možnost';
			}
		},
	},
};
</script>
